import { memo, useEffect } from 'react';

import { hideZendeskWidget, showZendeskWidget } from '@/shared/lib/helpers/zendesk-widget.helper';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';

import { useModals } from '../../model/selectors/select-modals';
import { useModalActions } from '../../model/slice/modal.slice';
import * as Styled from './modal-container.styles';

const ModalContainerComponent = () => {
	const modals = useModals();
	const { removeModal } = useModalActions();
	const isMobile = useMatchMedia('mobile');
	const hasOpenModal = Boolean(modals.length);

	useEffect(() => {
		if (!hasOpenModal) return;

		hideZendeskWidget();

		return showZendeskWidget;
	}, [hasOpenModal]);

	if (!hasOpenModal) {
		return null;
	}

	return (
		<>
			{modals.map(({ id, component: Component, isOverlayClose, variant }) => {
				if (variant === 'standalone') {
					return <Component key={id} />;
				}

				const handleClose = () => {
					if (isOverlayClose) {
						removeModal(id);
					}
				};

				if (isMobile) {
					return <Component key={id} />;
				}

				return (
					<Styled.Dialog key={id} variant={variant} open onClose={handleClose}>
						<Styled.Panel variant={variant} className="panel">
							<Component />
						</Styled.Panel>
					</Styled.Dialog>
				);
			})}
		</>
	);
};

export default memo(ModalContainerComponent);
